import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { AppName, CleanMessage } from "../../../../util/app";
import AddButton from "../../../../partials/Buttons/AddButton";
import NewInterestChecklistForm from "./NewInterestChecklistForm";
import { useMutation, useQuery } from "react-apollo";
import { NEW_INTEREST_CHECKLIST, GET_INTEREST_CHECKLIST } from "../../../../queries/interest-checklist.query";
import { toast } from "react-toastify";
import { ReadData } from "../../../../providers/Patient.Provider";
import LoadingSpinner from "../../../../partials/loading";
import InterestChecklistList from "./list";
import InterestCheckListDetail from "./Detail";

const InterestCheckList = ({ match }) => {
    const { id } = match.params;

    const patient = ReadData();
    const [Interest, setInterest] = useState(null);
    const [newInterest, setNewInterest] = useState(false);

    const scrollTop = () => {
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
    };

    const { loading: _Loading, data } = useQuery(GET_INTEREST_CHECKLIST, {
        onError: e => toast.error(CleanMessage(e.message)),
        variables: {
            patient: id
        }
    });

    const [createFunc, { loading }] = useMutation(NEW_INTEREST_CHECKLIST, {
        onError: e => toast.error(CleanMessage(e.message)),
        onCompleted: d => {
            if (d.RecordNewInterestCheckList) {
                toast.success(d.RecordNewInterestCheckList.message);
                setNewInterest(false);
                setInterest(null);
            }
        },
        update: (caches, { data: { RecordNewInterestCheckList } }) => {
            const { GetPatientInterestCheckLists } = caches.readQuery({
                query: GET_INTEREST_CHECKLIST,
                variables: { patient: id }
            });
            GetPatientInterestCheckLists.docs.unshift(RecordNewInterestCheckList.doc);
            caches.writeQuery({
                query: GET_INTEREST_CHECKLIST,
                variables: { patient: id },
                data: { GetPatientInterestCheckLists }
            });
        }
    });

    const title = "Patient Interest Checklist";
    return (
        <>
            <Helmet>
                <title>
                    {title} | {AppName}
                </title>
            </Helmet>

            <div className="row">
                <div className="col-12">
                    <LoadingSpinner loading={_Loading} />
                    {!newInterest && !Interest && (
                        <div className="card fade-in">
                            <div className="card-head">
                                <header>{title}</header>
                                <div className="float-right mt-2 mr-2">
                                    <AddButton
                                        title="Add"
                                        onClick={() => {
                                            setNewInterest(true);
                                            setInterest(null);
                                            scrollTop();
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="card-body" style={{ minHeight: "450px" }}>
                                {data && (
                                    <InterestChecklistList
                                        onView={item => {
                                            setNewInterest(false);
                                            setInterest(item);
                                            scrollTop();
                                        }}
                                        items={data.GetPatientInterestCheckLists.docs}
                                    />
                                )}
                            </div>
                        </div>
                    )}
                    {/* NEW SHORT TERM SERVICE ASSESSMENT */}
                    {newInterest && !Interest && (
                        <div className="card fade-in">
                            <div className="card-head">
                                <header>
                                    <button
                                        onClick={() => {
                                            setNewInterest(false);
                                            setInterest(null);
                                        }}
                                        title="Back"
                                        className="mdl-button mdl-button--icon margin-right-10 mdl-button--colored"
                                    >
                                        <i className="material-icons text-primary">keyboard_backspace</i>
                                    </button>
                                    New {title}
                                </header>
                            </div>
                            <div className="card-body">
                                <NewInterestChecklistForm
                                    onCancel={() => {
                                        setNewInterest(false);
                                        setInterest(null);
                                        scrollTop();
                                    }}
                                    onSubmit={async model => {
                                        await createFunc({
                                            variables: {
                                                model: {
                                                    ...model,
                                                    patient: id,
                                                    admission: patient.lastAdmission
                                                }
                                            }
                                        });
                                    }}
                                />
                                <LoadingSpinner loading={loading} />
                            </div>
                        </div>
                    )}

                    {/* DETAIL OF SHORT TERM SERVICE ASSESSMENT */}
                    {!newInterest && Interest && (
                        <div className="card fade-in">
                            <div className="card-head">
                                <header>
                                    <button
                                        onClick={() => {
                                            setNewInterest(false);
                                            setInterest(null);
                                        }}
                                        title="Back"
                                        className="mdl-button mdl-button--icon margin-right-10 mdl-button--colored"
                                    >
                                        <i className="material-icons text-primary">keyboard_backspace</i>
                                    </button>
                                    {title} Detail Page
                                </header>
                            </div>
                            <div className="card-body">
                                <InterestCheckListDetail item={Interest} />
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </>
    );
};

export default InterestCheckList;
